import React from "react";
import { useSelector } from "react-redux";
import SideBarContentV2 from "./SideBarContentV2";
import TopBarV2 from "../topbar/TopBarV2";
import { sidebarSelector } from "../../redux/reducers/sidebar";
import useIsMobile from "../../hooks/isMobile";
import "../../styles-v2/sidebar/v2-sidebar.css";

const SideBarV2 = ({ children }) => {
  const isOpen = useSelector(sidebarSelector);
  const isMobile = useIsMobile();

  const contentClass = `v2-layout__content ${isMobile
      ? ""
      : isOpen
        ? "v2-layout__content--sidebar-expanded"
        : "v2-layout__content--sidebar-collapsed"
    }`;

  return (
    <div className="v2-layout">
      <SideBarContentV2 />
      <TopBarV2 />
      <main className={contentClass}>{children}</main>
    </div>
  );
};

export default SideBarV2;
